import { useMemo } from "react";
import styles from "./styles.module.scss";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";
import Markdown from "@/components/atoms/Markdown";
import addLineBreaks from "@/helpers/addLineBreaks";
import { imgPathReplace } from "@/helpers/imgPathReplace";

export default function ImageWithListCard({ Title, Subtitle, Image }) {
  const img = useMemo(() => {
    return strapiSingleAttribute(Image);
  }, [Image]);
  return (
    <div className={styles.root}>
      <img 
      src={imgPathReplace(img?.url)}
      srcSet={imgPathReplace(img?.url)}
      alt={img?.alternativeText ||'Amity Online'} 
      width={380}
      height={532}
      title={img?.alternativeText ||'Amity Online'} 
      className={styles.img}
      loading="lazy" />
      <div className={styles.container}>
        <Markdown className={styles.title}>{addLineBreaks(Title)}</Markdown>
        <Markdown className={styles.subtitle}>{Subtitle}</Markdown>
      </div>
    </div>
  );
}
